export const GOOGLE_MAPS_API_KEY = "AIzaSyCy3XSIMTryloxQLZ5XnUi2o56YzbCcvf8";